module.exports = __webpack_public_path__ + "ef0b194fefa52dfa07ef5320ae142208.svg";